import { trackNewsletterSignup } from '@cotyorg/ccx-utils/js/tracking/adobe-dtm/events/newsletter';
import {
  NEWSLETTER_REQUEST_PENDING,
  NEWSLETTER_REQUEST_FAIL,
  NEWSLETTER_REQUEST_SUCCESS,
  RESET_NEWSLETTER,
  NEWSLETTER_SET_INPUT_VALUE,
  NEWSLETTER_RESET_INPUT_VALUE,
} from './types';

export const requestPending = pending => ({
  type: NEWSLETTER_REQUEST_PENDING,
  pending,
});

export const requestFail = status => ({
  type: NEWSLETTER_REQUEST_FAIL,
  status,
});

export const requestSuccess = () => ({
  type: NEWSLETTER_REQUEST_SUCCESS,
});

export const setInputValue = value => ({
  type: NEWSLETTER_SET_INPUT_VALUE,
  value,
});

export const resetInputValue = () => ({
  type: NEWSLETTER_RESET_INPUT_VALUE,
});

export const requestStart = ({ url, data }) => async (dispatch) => {
  dispatch(requestPending(true));

  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  });

  dispatch(requestPending(false));

  if (response.ok) {
    dispatch(requestSuccess());
    trackNewsletterSignup();
    dispatch(resetInputValue());
  } else {
    dispatch(requestFail(response.status));
  }

  return response;
};

export const resetNewsletter = () => ({
  type: RESET_NEWSLETTER,
});
